import React from "react";

const Error404 = () => {
  return (
    <div className="mt-10 text-4xl font-rob flex items-center text-red-500 justify-center">
      <div>Error404 NOT FOUND</div>
    </div>
  );
};

export default Error404;
